﻿export class PrintPreview {
  public static wireup() {
    document.addEventListener('click', function (e: Event) {
      let element = e.target as HTMLElement;
      if (!element.matches('[data-print]'))
        return;

      let id = element.getAttribute('data-print');
      let iframe = document.querySelector('print-preview'.asDataSelector(id)).querySelector('iframe') as HTMLIFrameElement;
      iframe.focus();
      try {
        iframe.contentWindow.document.execCommand('print', false, null)
      }
      catch (e) {
        iframe.contentWindow.print();
      }
    });
  }
}